const getSessionLangPath = (locale: LanguageCode) => {
  if (locale.length && locale !== 'en') {
    return `/${locale}`;
  }
  return '';
};

export default getSessionLangPath;
